<section class="form-button-container">
  <div class="button-container">
    <!-- // Todo: #fixme - looks like the value of isFormValid is not being used correctly. if isFormValid is true, then the button should be enabled, it is coded backwards -->
    <button
      class="formBtn"
      [type]="inputType"
      [disabled]="isFormValid"
      [class.active]="!isFormValid"
      (click)="emitButtonClick()"
    >
      <span class="label" [class.active]="!isFormValid">{{ buttonText }}</span>
    </button>
  </div>
</section>
